<!--
 * @Description: 听课记录 修改
 * @Author: 王赵坤
 * @Date: 2023-01-06 15:13:53
 * @LastEditors: PF
 * @LastEditTime: 2024-06-26 17:52:49
-->

<template>
  <div>
    <el-dialog class="wp88 hp88" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="jilumoban" :rules="rules" label-width="120px" class="demo-ruleForm" status-icon>
        <el-row>
          <el-col :span="12" class="lightgreen-box">
            <el-form-item label="" prop="jcdm">
              <el-button type="primary" @click="xvanzekecheng">选择课程</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">

          </el-col>
          <el-col :span="12" class="lightgreen-box">
            <el-form-item label="班级:" prop="cbh">
              <span>{{banjidata.bjmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item label="课程:" prop="dyzz">
              <span>{{banjidata.kcmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item label="星期:" prop="cbs">
              <span v-if="banjidata.xq">
                星期<span v-if="banjidata.xq == 1">一</span>
                <span v-if="banjidata.xq == 2">二</span>
                <span v-if="banjidata.xq == 3">三</span>
                <span v-if="banjidata.xq == 4">四</span>
                <span v-if="banjidata.xq == 5">五</span>
                <span v-if="banjidata.xq == 6">六</span>
                <span v-if="banjidata.xq == 7">日</span>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item label="节次:" prop="cbs">
              <span v-if="banjidata.jc">第{{banjidata.jc}}节</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item prop="csrq" label="地点:">
              <span>{{banjidata.jxcdmcs}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="orange-box">
            <el-form-item label="听课日期:" prop="dj">
              <span>{{banjidata.tkrq}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="orange-box" v-for="(domain, index) in jilumoban.domains" :key="index">
            <!-- [1]单行文本 [2]多行文本 [3]数字 [4]下拉框 [5]单选 [6]多选 [7]日期 [8]日期区间 [99]标签 -->
            <el-form-item v-if="domain.lx === 1" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-input v-model="domain.inputVal" :placeholder="domain.tswz" :maxlength="domain.zdcd" show-word-limit />
            </el-form-item>
            <el-form-item v-if="domain.lx === 2" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-input type="textarea" v-model="domain.inputVal" :placeholder="domain.tswz" :rows="domain.mrhs" :maxlength="domain.zdcd" show-word-limit  />
            </el-form-item>
            <el-form-item v-if="domain.lx === 3" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <div class="shu_zi_kuang" :class="!domain.qz && !domain.hz ? 'wu_zhui' : !domain.qz ? 'wu_qian_zhui' : !domain.hz ? 'wu_hou_zhui' : 'you_zhui'">
                <div class="qian_zhui" v-if="domain.qz">{{domain.qz}}</div>
                <el-input-number v-if="!domain.zdz && !domain.zxz && !domain.xsjd" v-model="domain.inputVal"></el-input-number>
                <el-input-number v-else-if="domain.zdz && !domain.zxz && !domain.xsjd" v-model="domain.inputVal" :max="domain.zdz"></el-input-number>
                <el-input-number v-else-if="!domain.zdz && domain.zxz && !domain.xsjd" v-model="domain.inputVal" :min="domain.zxz"></el-input-number>
                <el-input-number v-else-if="!domain.zdz && !domain.zxz && domain.xsjd" v-model="domain.inputVal" :step="domain.xsjd"></el-input-number>
                <el-input-number v-else-if="domain.zdz && domain.zxz && !domain.xsjd" v-model="domain.inputVal" :max="domain.zdz" :min="domain.zxz"></el-input-number>
                <el-input-number v-else-if="!domain.zdz && domain.zxz && domain.xsjd" v-model="domain.inputVal" :min="domain.zxz" :step="domain.xsjd"></el-input-number>
                <el-input-number v-else-if="domain.zdz && domain.zxz && domain.xsjd" v-model="domain.inputVal" :max="domain.zdz" :min="domain.zxz" :step="domain.xsjd"></el-input-number>
                <div class="hou_zhui" v-if="domain.hz">{{domain.hz}}</div>
              </div>
            </el-form-item>
            <el-form-item v-if="domain.lx === 4" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-select v-model="domain.inputVal" :placeholder="domain.tswz">
                <el-option v-for="item in domain.xxs" :key="item.id" :label="item.xxwb" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="domain.lx === 5" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-radio-group v-model="domain.inputVal" :placeholder="domain.tswz">
                <el-radio v-for="(item,index) in domain.xxs" :key="index" :label="item.id">{{ item.xxwb }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="domain.lx === 6" :label="domain.bt" :prop="'domains.' + index + '.inputArr'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-checkbox-group v-model="domain.inputArr" :placeholder="domain.tswz">
                <el-checkbox v-for="item in domain.xxs" :key="item.id" :label="item.id">{{ item.xxwb }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item v-if="domain.lx === 7" :label="domain.bt" :prop="'domains.' + index + '.inputVal'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-date-picker v-model="domain.inputVal" :type="domain.rqlx === 1 ? 'data' : 'datetime'" :format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :value-format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :placeholder="domain.tswz" style="width: 100%;" />
            </el-form-item>
            <el-form-item v-if="domain.lx === 8" :label="domain.bt" :prop="'domains.' + index + '.inputArr'" :rules="domain.sfbt ? [{required: true,message: domain.bt + '不能为空',trigger: 'blur'}] : [{required: false,trigger: 'blur'}]">
              <el-date-picker v-model="domain.inputArr" :type="domain.rqlx === 1 ? 'daterange' : 'datetimerange'" :format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :value-format="domain.rqlx === 1 ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm'" :placeholder="domain.tswz" range-separator="-" :start-placeholder="domain.tswz" :end-placeholder="domain.bt2" />
            </el-form-item>
            <el-form-item v-if="domain.lx === 99">
              <p style="width: 100%;color:#909399" :style="'font-size:' + domain.ztdx + ';color:' + domain.ztys + ';text-align:' + domain.dqfs === 2 ? 'center' : domain.dqfs === 3 ? 'right' : domain.dqfs === 4 ? 'justify' : 'left'">
                {{ domain.smwz }}
              </p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <el-dialog class="wp85 hp85" v-model="xvanzekechengis" modal="false" align-center="true" :before-close="handleClosekecheng" style="overflow: hidden;" :close-on-click-modal="false" destroy-on-close title="校历课表">
    <kecheng @gochuanshujvxl="gochuanshujvxl" />
  </el-dialog>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import {
  actionPost,
  submitEditForm,
  closeWindow,
  loadSelect
} from '@/api/common.js'
import kecheng from '@/pages/jiaowu/paikeguanli/xiaolikebiao/list.vue'
const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])

const banjidata = ref({
  bjmc: '',
  kcmc: '',
  jc: '',
  jxcdmcs: '',
  tkrq: ''
})
const xvanzekechengis = ref(false)
const ruleFormRef = ref(null)
const ruleForm = ref({})
const rules = ref({})

const jilumoban = ref({ domains: [] })
// 选择课程 传过来的最终数据
const gochuanshujvxl = (val, time, number) => {
  let id = val.xlbjkbid
  if (number === 1) {
    id = val.id
  } else if (number === 3) {
    id = val.xlbjkbid
  }
  loadSelect({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/detail',
    parms: { id: id },
    data: banjidata,
    loadSuccess: function () {
      banjidata.value.tkrq = time
    }
  })

  xvanzekechengis.value = false
}
const handleClosekecheng = () => {
  xvanzekechengis.value = false
}
const xvanzekecheng = () => {
  xvanzekechengis.value = true
}
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      actionPost({ url: '/api/v2/jiaowu/tingkejilu/' + props.row.id }).then((res) => {
        if (res.code === 200) {
          ruleForm.value.id = props.row.id
          jilumoban.value.domains = []
          banjidata.value = res.data
          res.data.mbzjs.forEach((item) => {
            item.inputVal = item.listBdz ? item.listBdz[0] : ''
            item.inputArr = item.listBdz ? item.listBdz : []
            jilumoban.value.domains.push(item)
          })
        } else {
          warningPrompt(res.message)
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  const array = []
  if (jilumoban.value.domains) {
    jilumoban.value.domains.forEach((item) => {
      const obj = {
        bdzjid: item.id,
        lx: item.lx,
        inputVal: item.inputVal,
        inputArr: item.inputArr
      }
      array.push(obj)
    })
  }
  ruleForm.value.xlbjkbid = banjidata.value.xlbjkbid
  ruleForm.value.mbbds = array
  submitEditForm({
    url: '/api/v2/jiaowu/tingkejilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
